import axios from 'axios';
import { ROOT_URL } from '../config/global';

export const createIntent = (data) => {
  axios.defaults.withCredentials = true;

  const request = axios({
    method: 'post',
      url: `${ROOT_URL}/api/intents`,
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache': 'no-cache',
      },
      data: JSON.stringify(data)
  },
  {withCredentials: true})

  return request;
};

export const updateIntent = (id, data) => {
  axios.defaults.withCredentials = true;

  const request = axios({
    method: 'put',
      url: `${ROOT_URL}/api/intents/${id}`,
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache': 'no-cache',
      },
      data: JSON.stringify(data)
  },
  {withCredentials: true})

  return request;
};


// WEBPACK FOOTER //
// ./src/redux/actions/intents.js